export const GET_FACES_AI_ASSISSTANT_STATUS = "GET_FACES_AI_ASSISSTANT_STATUS";
